var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#6621ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.118 1.1H5.882a3.52 3.52 0 0 0-3.515 3.515v22.77a3.52 3.52 0 0 0 3.515 3.516h20.236a3.52 3.52 0 0 0 3.515-3.516V4.615A3.52 3.52 0 0 0 26.118 1.1zm1.714 26.285c0 .945-.769 1.715-1.714 1.715H5.882c-.945 0-1.714-.77-1.714-1.715V4.615c0-.945.769-1.715 1.714-1.715h20.236c.945 0 1.714.77 1.714 1.715z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#6621ba",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.032 19.794H9.968a.9.9 0 0 0 0 1.8h12.064a.9.9 0 0 0 0-1.8zM19.476 23.958h-6.951a.9.9 0 0 0 0 1.8h6.951a.9.9 0 0 0 0-1.8z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#6621ba",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M11.29 17.437a.9.9 0 0 0 1.238-.296c.453-.736 1.702-1.479 3.472-1.479s3.019.743 3.472 1.479a.9.9 0 0 0 1.534-.942c-.428-.696-1.121-1.27-1.97-1.675 1.016-.865 1.675-2.136 1.675-3.571 0-2.597-2.113-4.71-4.71-4.71s-4.71 2.113-4.71 4.71c0 1.435.659 2.707 1.675 3.571-.849.406-1.542.979-1.97 1.675a.899.899 0 0 0 .294 1.238zm1.801-6.485c0-1.604 1.305-2.91 2.909-2.91s2.909 1.306 2.909 2.91-1.305 2.91-2.909 2.91-2.909-1.306-2.909-2.91z",
    opacity: 1,
    "data-original": "#f98a17",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f139b8eef496a0292d74bb7d36be2471.svg";
export { ForwardRef as ReactComponent };